/*
 * Close button for the full-height menu drawer.
 *
 * The drawer covers the header, so the header's own hamburger/X sits behind
 * it and can no longer be used to close the menu — the drawer carries its own
 * X (.menu-drawer__dismiss, see header-drawer.liquid).
 *
 * Closing goes through closeMenuDrawer() on purpose. Dawn's MenuDrawer binds
 * every <button> inside the drawer to onCloseButtonClick, which only calls
 * closeSubmenu(): that hides the panel but leaves the overflow-hidden-* class
 * on <body>, so the page behind would stay locked and unscrollable.
 * closeMenuDrawer() is the method that also releases that scroll lock.
 * Running after Dawn's own (element-level) handler is harmless — both paths
 * end in the same closed state.
 */
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.menu-drawer__dismiss');
    if (!trigger) return;

    var drawer = trigger.closest('header-drawer, menu-drawer');
    if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;

    drawer.closeMenuDrawer(event, drawer.querySelector('summary.header__icon--menu'));
  });
})();
